import React, { useState } from 'react';
import products from '../products'; // Assume products.js exports an array of product objects
import ProductPopup from './ProductPopup';

const Products = () => {
  const [popupUrl, setPopupUrl] = useState(null);

  return (
    <section style={{ padding: 24 }}>
      <h2>Products</h2>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 24 }}>
        {products.map((prod, idx) => (
          <div key={prod.id || idx} style={{
            border: '1px solid #eee', borderRadius: 8, padding: 16, width: 220, background: '#fafafa', boxShadow: '0 2px 8px #0001'
          }}>
            <h4>{prod.name}</h4>
            <p>{prod.description}</p>
            <button
              style={{ background: '#FF4500', color: '#fff', border: 'none', borderRadius: 4, padding: '6px 12px', cursor: 'pointer' }}
              onClick={() => setPopupUrl(prod.youtube)}
            >
              Watch Sample
            </button>
            <div style={{ marginTop: 8 }}>
              <button
                style={{ background: '#32CD32', color: '#fff', border: 'none', borderRadius: 4, padding: '4px 10px', cursor: 'pointer', fontSize: 14 }}
                onClick={() => alert(`Quick access to ${prod.name}`)}
              >
                Quick Access
              </button>
            </div>
          </div>
        ))}
      </div>
      <ProductPopup videoUrl={popupUrl} onClose={() => setPopupUrl(null)} />
    </section>
  );
};

export default Products;
